import type {QueryFunctionContext} from 'react-query'
import type {Pet, PetResponse} from '@/models/consumer-engagement-models'
import {http} from '@/services/http'
import type {
	SinglePetQueryKey,
	PetFormData,
} from '@/services/pet-profiles/models'
import type {Result} from '@/utilities/types'

export const fetchPetProfiles = async (locale: string): Promise<Pet[]> => {
	const endpoint = `/api/petProfiles?locale=${locale}`
	const {data: response} = await http<Result<PetResponse>>(endpoint)

	if (!response.success) {
		throw new Error('Failed to fetch pet profiles')
	}
	return response.data.data
}

export const fetchSinglePetProfile = async (
	context: QueryFunctionContext<SinglePetQueryKey>,
	locale: string
): Promise<Pet> => {
	const [, params] = context.queryKey
	const endpoint = `/api/pets/${params.id}?locale=${locale}`
	const {data: response} = await http<Result<Pet>>(endpoint)

	if (!response.success) {
		throw new Error('Failed to create pet profile')
	}

	return response.data
}

export const createPetProfile = async (
	petData: PetFormData,
	locale: string
): Promise<Pet> => {
	const {data: response} = await http<Result<Pet>>(
		`/api/petProfiles?locale=${locale}`,
		{
			method: 'POST',
			data: {
				name: petData.petName,
				gender: petData.petSex,
				breed: petData.breed,
				species: petData.petSpecies,
				birthDate: petData.petDateOfBirth,
				weight: Number(petData.petWeight),
				acquisitionSource: petData.petAcquisitionType,
				acquisitionDate: petData.petAcquisitionDate,
				petShelterId: petData.petShelter,
				petShelterName: petData.shelterName,
				vetClinicId: petData.vetClinic,
				vetClinicName: petData.clinicName,
				imageReference: petData.imageReference,
			},
		}
	)

	if (!response.success) {
		throw new Error('Failed to fetch pet profile')
	}

	return response.data
}
